import { inject } from '@angular/core';
import { Routes } from '@angular/router';
import { FeatureFlagsService } from '@privanot/shared-ui/providers';
import { authGuard } from '@admin/auth/guards/auth.guard';
import { anonymousGuard } from '@admin/auth/guards/anonymous.guard';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
    },
    {
        path: 'auth',
        canActivate: [anonymousGuard],
        loadChildren: () => import('@admin/auth/authentication.routes').then((m) => m.AUTHENTICATION_ROUTES),
    },
    {
        // Authenticated routes (anything that has header + sidebar)
        path: '',
        canActivate: [authGuard],
        loadComponent: () => import('@admin/shared/components/layout/admin-main-layout/admin-main-layout').then((m) => m.AdminMainLayout),
        children: [
            {
                path: 'home',
                loadChildren: () => import('@admin/home/home.routes').then((m) => m.HOME_ROUTES),
            },
            {
                path: 'work-packages',
                data: { breadcrumb: 'sidebar.pages.workPackages' },
                loadChildren: () => import('@admin/work-packages/work-packages.routes').then((m) => m.WORK_PACKAGES_ROUTES),
            },
            {
                path: 'clients',
                data: { breadcrumb: 'sidebar.pages.clients' },
                loadChildren: () => import('@admin/clients/clients.routes').then((m) => m.CLIENTS_ROUTES),
            },
            {
                path: 'device-approvals',
                canMatch: [() => inject(FeatureFlagsService).enabled('deviceApprovals')],
                data: { breadcrumb: 'sidebar.pages.deviceApprovals' },
                loadChildren: () => import('@admin/ssh-keys/ssh-keys.routes').then((m) => m.SSH_KEYS_ROUTES),
            },
        ],
    },
    {
        path: '**',
        redirectTo: 'home',
    },
];
